import { FEE_POST_FAILURE, FEE_POST_REQUEST, FEE_POST_SUCCESS } from 'actions';

const initialState = {
    posting: false,
    hasErrors: false,
    fee: null,
};

export const postReducer = (state = initialState, action) => {
    const { type, fee } = action;
    switch (type) {
        case FEE_POST_REQUEST: return { ...initialState, posting: true };
        case FEE_POST_SUCCESS: return { ...initialState, fee };
        case FEE_POST_FAILURE: return { ...initialState, hasErrors: true };
        default: return state;
    }
};
